module.exports = __webpack_public_path__ + "assets/img/free_28.a47c9538.png";